import images from "./images";

const windowIntro = {
    sub: "Discover Our Windows",
    heading: "Experience the Beauty of Quality Windows",
    description: [
        "At Windows & Doors, we're dedicated to providing top-quality windows that enhance the aesthetics and functionality of your home. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus."
    ],
    points: [
        "Wide Selection of Window Styles",
        "Energy-Efficient Window Solutions",
        "Custom Window Design Options",
        "Professional Window Installation",
        "Expert Window Consultation & Support",
    ],
    image: {
        src1: images.window1,
        src2: images.window2,
        src3: images.window3,
        src4: images.window4,
        alt1: "Window Image 1",
        alt2: "Window Image 2",
        alt3: "Window Image 3",
        alt4: "Window Image 4",
    },
};

const windowFaqs = [
    {
        id: 1,
        heading: "What is the window installation process?",
        content: "Discover the step-by-step process involved in installing windows in your home. From measurement to fitting, learn how professionals ensure a seamless installation.",
    },
    {
        id: 2,
        heading: "How do windows contribute to energy efficiency?",
        content: "Explore how choosing the right windows can enhance the energy efficiency of your home. Learn about features and materials that help in reducing energy consumption.",
    },
    {
        id: 3,
        heading: "What maintenance is required for windows?",
        content: "Understand the maintenance tasks necessary to keep your windows in optimal condition. From cleaning to inspections, learn how to prolong the lifespan of your windows.",
    },
    {
        id: 4,
        heading: "What security features do your windows offer?",
        content: "Discover the security enhancements integrated into our windows to ensure the safety of your home. Learn about locks, reinforcements, and other features designed for security.",
    },
    {
        id: 5,
        heading: "Do you offer customization options for windows?",
        content: "Explore the customization possibilities available for our windows. From size and style to color and materials, learn how you can tailor windows to match your preferences and home design.",
    },
];


const windows = [
    {
        id: 1,
        image: images.window1,
        title: "Casement Window",
        details: {
            frameMaterial: "Vinyl, Wood, Aluminum",
            glassType: "Double-pane Low-E, Tempered, Obscure",
            dimensions: "Custom Sizes Available",
            energyEfficiency: "Energy Star Rated, Low U-factor, SHGC",
            securityFeatures: "Multi-Point Locking System, Impact-Resistant Glass",
            soundproofing: "Double-glazed Windows, Acoustic Insulation",
            weatherproofing: "Triple Weatherstripping, Durable Seals",
            warranty: "10-Year Limited Warranty, Lifetime Warranty",
            customizationOptions: "Grid Patterns, Hardware Finishes, Decorative Glass"
        },
        paragraphs: [
            "Discover the features and benefits of our Casement Windows.",
            "Our Casement Windows are designed to provide exceptional performance and aesthetics. With advanced features and durable construction, they offer security, energy efficiency, and beauty for your home."
        ],
        gallery: [
            images.window1Gallery1,
            images.window1Gallery2,
            images.window1Gallery3,
            images.window1Gallery4,
            images.window1Gallery5,
            images.window1Gallery6,
        ],
        styles: [
            "Sleek and Modern Design",
            "Variety of Frame Material Options",
            "Customizable Grid Patterns"
        ],
        features: [
            "Enhanced Security with Multi-Point Locking System",
            "Superior Energy Efficiency with Low-E Glass",
            "Reduced Outdoor Noise with Acoustic Insulation"
        ],
        specifications: [
            "Weatherproofing with Triple Weatherstripping",
            "Impact-Resistant Glass for Added Security",
            "Custom Sizes to Fit Your Home's Needs"
        ]
    },
    {
        id: 2,
        image: images.window2,
        title: "Picture Window",
        details: {
            frameMaterial: "Vinyl, Wood, Aluminum",
            glassType: "Double-pane Low-E, Tempered, Obscure",
            dimensions: "Custom Sizes Available",
            energyEfficiency: "Energy Star Rated, Low U-factor, SHGC",
            securityFeatures: "Multi-Point Locking System, Impact-Resistant Glass",
            soundproofing: "Double-glazed Windows, Acoustic Insulation",
            weatherproofing: "Triple Weatherstripping, Durable Seals",
            warranty: "10-Year Limited Warranty, Lifetime Warranty",
            customizationOptions: "Grid Patterns, Hardware Finishes, Decorative Glass"
        },
        paragraphs: [
            "Discover the features and benefits of our Picture Windows.",
            "Our Picture Windows offer expansive views, exceptional natural lighting, and a sleek design. With energy-efficient options and superior durability, they are perfect for modern and traditional homes alike."
        ],
        gallery: [
            images.window2Gallery1,
            images.window2Gallery2,
            images.window2Gallery3,
            images.window2Gallery4,
            images.window2Gallery5,
            images.window2Gallery6,
        ],
        styles: [
            "Frameless View-Focused Design",
            "Large Fixed Glass Panels",
            "Clean and Minimalist Appearance"
        ],
        features: [
            "Maximized Natural Light and Views",
            "Enhanced Energy Efficiency",
            "Ideal for Living Rooms and Open Spaces"
        ],
        specifications: [
            "Fixed Panel, No Moving Parts",
            "Weather-Sealed for Maximum Insulation",
            "Available in Large Custom Sizes"
        ]
    },
    {
        id: 3,
        image: images.window3,
        title: "Sliding Window",
        details: {
            frameMaterial: "Vinyl, Wood, Aluminum",
            glassType: "Double-pane Low-E, Tempered, Obscure",
            dimensions: "Custom Sizes Available",
            energyEfficiency: "Energy Star Rated, Low U-factor, SHGC",
            securityFeatures: "Multi-Point Locking System, Impact-Resistant Glass",
            soundproofing: "Double-glazed Windows, Acoustic Insulation",
            weatherproofing: "Triple Weatherstripping, Durable Seals",
            warranty: "10-Year Limited Warranty, Lifetime Warranty",
            customizationOptions: "Grid Patterns, Hardware Finishes, Decorative Glass"
        },
        paragraphs: [
            "Upgrade your home with our modern Sliding Windows designed for convenience and space efficiency.",
            "Sliding Windows glide smoothly along horizontal tracks, making them perfect for rooms with limited exterior space. With energy-efficient features and a sleek appearance, they offer style and function in one package."
        ],
        gallery: [
            images.window3Gallery1,
            images.window3Gallery2,
            images.window3Gallery3,
            images.window3Gallery4,
            images.window3Gallery5,
            images.window3Gallery6,
        ],
        styles: [
            "Smooth Horizontal Glide System",
            "Space-Saving Track Design",
            "Modern Frame Finishes"
        ],
        features: [
            "Effortless Operation and Ventilation",
            "Ideal for Compact Spaces",
            "Contemporary Aesthetic Appeal"
        ],
        specifications: [
            "Durable Track and Roller System",
            "Secure Locking Mechanisms",
            "Low-Maintenance Components"
        ]
    },
    {
        id: 4,
        image: images.window4,
        title: "Skylight Window",
        details: {
            frameMaterial: "Vinyl, Wood, Aluminum",
            glassType: "Double-pane Low-E, Tempered, Obscure",
            dimensions: "Custom Sizes Available",
            energyEfficiency: "Energy Star Rated, Low U-factor, SHGC",
            securityFeatures: "Multi-Point Locking System, Impact-Resistant Glass",
            soundproofing: "Double-glazed Windows, Acoustic Insulation",
            weatherproofing: "Triple Weatherstripping, Durable Seals",
            warranty: "10-Year Limited Warranty, Lifetime Warranty",
            customizationOptions: "Grid Patterns, Hardware Finishes, Decorative Glass"
        },
        paragraphs: [
            "Brighten up your interiors with our expertly designed Skylight Windows that bring natural light from above.",
            "Our Skylight Windows enhance ventilation, boost natural light, and add architectural elegance. Engineered for performance and energy efficiency, they’re ideal for kitchens, bathrooms, and lofts."
        ],
        gallery: [
            images.window4Gallery1,
            images.window4Gallery2,
            images.window4Gallery3,
            images.window4Gallery4,
            images.window4Gallery5,
            images.window4Gallery6,
        ],
        styles: [
            "Flat and Domed Designs",
            "Manual or Remote Opening Options",
            "UV-Protected Glazing Options"
        ],
        features: [
            "Increased Natural Light and Ventilation",
            "Enhances Room Ambience and Energy Efficiency",
            "Perfect for Bathrooms, Kitchens, and Lofts"
        ],
        specifications: [
            "Leak-Proof Flashing System",
            "Impact-Resistant Glazing",
            "Custom Sizes and Tilt Angles Available"
        ]
    },
    {
        id: 5,
        image: images.window5,
        title: "Double-Hung Window",
        details: {
            frameMaterial: "Vinyl, Wood, Composite",
            glassType: "Double-pane, Low-E, Argon-Filled",
            dimensions: "Standard and Custom Sizes",
            energyEfficiency: "Energy Star Certified, Low U-Factor",
            securityFeatures: "Tilt Latches, Secure Locking System",
            soundproofing: "Insulated Glass Units, Enhanced Seals",
            weatherproofing: "Weatherstripping, Water-Resistant Frames",
            warranty: "Limited Lifetime Warranty",
            customizationOptions: "Grid Patterns, Colors, Hardware Finishes"
        },
        paragraphs: [
            "Classic and versatile, our Double-Hung Windows offer smooth operation and timeless appeal for any home style.",
            "Designed with two operable sashes for superior ventilation and easy cleaning, these windows combine traditional aesthetics with modern performance features."
        ],
        gallery: [
            images.window5Gallery1,
            images.window5Gallery2,
            images.window5Gallery3,
            images.window5Gallery4,
            images.window5Gallery5,
            images.window5Gallery6,
        ],
        styles: [
            "Traditional Colonial Look",
            "Contemporary Design Options",
            "Various Color and Finish Choices"
        ],
        features: [
            "Both Sashes Tilt for Easy Cleaning",
            "Improved Airflow and Ventilation",
            "Low-Maintenance and Durable"
        ],
        specifications: [
            "Fusion-Welded Frame and Sashes",
            "Reinforced Meeting Rails",
            "Balance System for Smooth Operation"
        ]
    },
    {
        id: 6,
        image: images.window6,
        title: "Bay Window",
        details: {
            frameMaterial: "Vinyl, Wood, Fiberglass",
            glassType: "Double-pane, Low-E, Tinted",
            dimensions: "Custom Width and Projection Options",
            energyEfficiency: "Energy Star Certified, Insulated Glass Units",
            securityFeatures: "Reinforced Locks, Secure Hardware",
            soundproofing: "Multi-Layer Glass, Noise-Reducing Seals",
            weatherproofing: "Sealed Frames, Weather-Resistant Construction",
            warranty: "10-Year Structural Warranty, Limited Glass Warranty",
            customizationOptions: "Seat Board Finishes, Grid Styles, Roof Styles"
        },
        paragraphs: [
            "Bay Windows are perfect for creating extra interior space while enhancing the architectural charm of your home.",
            "They allow abundant natural light and panoramic views, making them ideal for cozy reading nooks or decorative displays."
        ],
        gallery: [
            images.window6Gallery1,
            images.window6Gallery2,
            images.window6Gallery3,
            images.window6Gallery4,
            images.window6Gallery5,
            images.window6Gallery6,
        ],
        styles: [
            "Contemporary Angled Design",
            "Traditional 3-Panel Configuration",
            "Custom Seat Board Materials"
        ],
        features: [
            "Expanded Interior Space",
            "Maximized Daylight Exposure",
            "Improved Home Aesthetics"
        ],
        specifications: [
            "Projection Options: 30°, 45°, 90°",
            "High-Performance Glass Packages",
            "Factory-Assembled for Precision Fit"
        ]
    }

];

export { windowIntro, windowFaqs, windows };